<div #homeContainer class="home-container page-container no-scrollbar" [class.results-at-top]="isAtTopPosition()"
  [class.results-at-bottom]="!isAtTopPosition()">
  <!-- <div class="background-gradient"></div> -->

  <!-- Programming Panel for Testing (Programming Mode Only) -->
  @if (isProgrammingMode()) {
  <app-programming-panel></app-programming-panel>
  }


  <div class="inner-scroll top-pane right-pane no-scrollbar"
    [ngClass]="{ 'background-opacity shadow-heavy': isFiltersExpanded}" [class.background-opacity]="isFiltersExpanded">
    <app-recycling-filters class="search-controls" [showSearch]="true"
      [searchPlaceholder]="'home.searchPlaceholder' | t" [hasLocation]="hasLocation()"
      [currentLocationName]="getCurrentLocationName()" [isLocationLoading]="isLocationLoading()"
      [locationError]="locationError()" [userLocation]="userLocation()"
      [totalPoints]="filteredRecyclingPointsStats().totalPoints"
      [topMaterialsLength]="containerStats().topMaterials.length" [closestDistance]="containerStats().closestDistance"
      [topMaterialsText]="getTopMaterialsText()" [variant]="'home'"
      [nearbyDistanceMeters]="resultsSummaryDistanceMeters()" [nearbyMaterials]="resultsSummaryMaterials()"
      [typeCounts]="filteredRecyclingPointsStats().typeCounts" (filtersExpanded)="filtersExpanded($event)"
      (searchRequested)="onSearchRequested()" (nearbyClick)="onNearbyResultClick()"
      (expandLocationComponent)="expandLocationComponent($event)" (requestLocation)="requestLocation()"
      (activatePinMode)="activatePinMode()" (locationSelected)="onLocationSelected($event)">
    </app-recycling-filters>
    <div class="spacer-to-scroll">
    </div>
  </div>


  <div #wrapperListScroll class="otra-caja no-scrollbar wrapperListScroll left-pane">
    <!-- <div class="map-placement" [style.height]='mapHeight'> -->
    <div class="map-placement">
    </div>

    <div #resultsSection class="results-section padding-y-s hidden-when-modal modal-active-listener shadow-heavy"
      [class.hidden-for-pin-mode]="isPinModeActive">

      <div #listInnerScroll class="inner-scroll list-inner-scroll padding-x-s">
        <div class="list-header padding-b-sm" [class.bottom-position]="!isAtTopPosition()">
          <!-- Type toggles - no labels, compact -->
          <div class="list-type-filters">
            <app-type-toggles variant="compact" [showLabels]="false"
              [typeCounts]="viewportTypeCounts()"></app-type-toggles>
            @if (hasLocation() && resultsSummaryMaterials().length > 0) {
            <app-nearby-result [distanceMeters]="resultsSummaryDistanceMeters()" [materials]="resultsSummaryMaterials()"
              (nearbyClick)="onNearbyResultClick()">
            </app-nearby-result>
            }
          </div>

        </div>
        <!-- Paginated results -->
        @if (paginationInfo.totalPages > 1) {
        <app-horizontal-page-picker [paginationInfo]="paginationInfo" [headerTitle]="'home.page' | t"
          (pageChange)="goToPage($event)" (previousPage)="prevPage()" (nextPage)="nextPage()" class="margin-t-x">
        </app-horizontal-page-picker>
        }
        @for (point of paginatedPoints(); track point.id) {
        <app-switch-point-card id="point-{{ point.id }}" class="result-card" [data]="point"
          [isSelected]="isPointSelected(point)" [distance]="getDistanceToPoint(point)"
          [scheduleDays]="getScheduleDays(point)" [scheduleHoursText]="getScheduleHoursText(point)"
          (cardClick)="onPointClick($event)" (titleClick)="onPointClick(point)" (descriptionClick)="onPointClick(point)"
          (addressClick)="onPointClick(point)" (materialsClick)="onPointClick(point)"
          (scheduleClick)="onPointClick(point)" (contactClick)="onPointClick(point)">
        </app-switch-point-card>
        }

        <!-- Empty state when no results -->
        @if (paginatedPoints().length === 0) {
        <app-create-new-point></app-create-new-point>
        }

        <!-- Bottom Pagination controls - only show when at top position -->
        @if (isAtTopPosition() && paginationInfo.totalPages > 1) {
        <app-horizontal-page-picker [paginationInfo]="paginationInfo" [headerTitle]="'home.page' | t"
          (pageChange)="goToPage($event)" (previousPage)="prevPage()" (nextPage)="nextPage()" class="margin-b-m">
        </app-horizontal-page-picker>
        }

        <!-- Schedule Entities Section removed - routes/areas now shown in unified list above -->
        <div class="spacing-100">
        </div>
        <div class="spacing-100">
        </div>
      </div>
    </div>

  </div>


  <!-- Toggle Button for Map/List View -->
  <div class="view-toggle pointer-events-none">
    <div class="push-btn btn-sm shadow-m gray-secondary-button">
      <button class="view-toggle-btn h4 shadow-heavy pointer-events-all inner-button" (click)="toggleView()"
        [class.hidden-for-pin-mode]="isPinModeActive">
        <span class="toggle-text padding-x-s h4-semibold">{{ toggleButtonText() }}</span>
        @if (isLoadingPoints() && !isAtTopPosition()) {
        <!-- Spinner while loading and showing "ver lista" -->
        <span class="loading-spinner"></span>
        } @else if (isAtTopPosition()) {
        <!-- Map icon for "ver mapa" -->
        <!-- <img src="assets/img/map-sample.png" alt="Mapa" class="btn-icon icon-24"> -->
        <img class="icon  icon-text-primary icon-24" src="assets/icons/map.svg" alt="map" />

        } @else {
        <!-- List icon for "ver lista" -->
        <img class="icon icon-text-primary icon-24" src="assets/icons/chevron-up.svg" alt="list" />
        }
      </button>
    </div>
  </div>

  <!-- "Buscar acá" button -->
  <!-- <div class=" search-here-btn  push-btn primary-invert-color-button btn-s  "> -->
<!--   @if (showSearchHereButton()) {
  <div class="search-here-btn push-btn gray-secondary-button btn-s shadow-sm"
    [class.with-active-filters]="hasActiveFilters()">
    <button class="inner-button pointer-events-all" (click)="onSearchHereClick()">
      <img class="icon icon-text-primary icon-20" src="assets/icons/locate-outline.svg" [alt]="'common.search' | t" />
      <span class="h4-semibold">{{ 'home.searchHere' | t }}</span>
    </button>
  </div>
  }
 -->
  <div class="map-container">
    <app-maplibre-map #mapComponent [markers]="filteredMapMarkers()" [selectedMarkerId]="selectedPointId"
      [nearbyMarkerId]="nearbyPointId()" [height]="'100dvh'" [showFullscreenButton]="true"
      [showPinButton]="!hasLocation()" [userLocation]="userLocation()" [selectedMaterials]="selectedMaterialValues()"
      [initialCenter]="savedMapPosition()" [initialZoom]="savedMapZoom()" (mapInteraction)="onMapInteraction($event)"
      (pinPlaced)="onPinPlaced($event)" (pinModeChange)="onPinModeChange($event)"
      (openLocationInput)="openLocationInputModal()">
      <!-- (fullscreenChange)="onFullscreenChange($event)" - Disabled: fullscreen logic removed -->
    </app-maplibre-map>

    @if (showContainerPopup && containerPopupData) {
    <div class="container-popup-overlay fullscreen-popup" (click)="hideContainerPopup()">
      <!-- Always use fullscreen-popup class now - [class.fullscreen-popup]="isMapFullscreen" -->
      <div class="container-popup shadow-heavy" [style.left.px]="containerPopupPosition.x"
        [style.top.px]="containerPopupPosition.y" (click)="$event.stopPropagation()">
        <!-- 
        <div class="popup-close margin-x-s" (click)="hideContainerPopup()">
          <img src="/assets/icons/cruz.svg" class="icon-text-secondary icon" alt="">
        </div> -->
        <div class="popup-content">
          <div class="popup-address">
            <img class="popup-icon icon-24" src="assets/icons/container.svg" alt="Contenedor">
            <!-- <img class="popup-icon icon-text-secondary" src="assets/icons/location.svg" alt="Ubicación"> -->
            <span class="address-text p-semibold text-secondary notranslate" translate="no">{{
              getSimplifiedAddress(getAddressString(containerPopupData)) }}</span>
          </div>

          <div class="popup-materials">
            <div class="materials-list">
              <app-materials-pills [displayOnly]="true" [displayMaterials]="containerPopupReorderedMaterials()"
                [showSearch]="false" [pillSize]="'md'">
              </app-materials-pills>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
  </div>


</div>